import { Box, Flex } from '@chakra-ui/react';
import { Container, IconButton, Layout, useTheme } from '@melio/penny';
import { Navigate, Route, Routes } from 'react-router-dom';

import { SubscriptionTabsEnum } from '../../../constants';
import { SubscriptionCheckoutActivity } from '../../SubscriptionCheckout';
import { SubscriptionPlansActivity } from '../../SubscriptionPlans';
import { SubscriptionTabs } from '../components/SubscriptionTabs';

export type SubscriptionWizardScreenProps = {
  returnUrl?: string;
  planId: string;
  currentTab?: string;
  onClose: () => void;
  onBack: () => void;
  onChangeTab: (tab: string) => void;
};
export const SubscriptionWizardScreen = ({
  returnUrl,
  planId,
  currentTab,
  onClose,
  onBack,
  onChangeTab,
}: SubscriptionWizardScreenProps) => {
  const theme = useTheme();
  const showWizardTabs = currentTab !== SubscriptionTabsEnum.Plans;
  return (
    <Layout
      variant="full"
      data-testid="subscription-wizard-screen"
      header={{
        content: (
          <Flex
            height="72px"
            flexDir="row"
            width="full"
            justifyContent="space-between"
            alignItems="center"
            px="m"
            borderBottom={`1px solid ${showWizardTabs ? theme.colors.neutral.light : 'transparent'}`}
          >
            {showWizardTabs && (
              <Box>
                <IconButton
                  aria-label="back"
                  icon="chevron-left"
                  variant="naked"
                  onClick={onBack}
                  data-testid="subscription-wizard-back-button"
                />
              </Box>
            )}

            {showWizardTabs && <SubscriptionTabs onChangeTab={onChangeTab} />}

            <IconButton aria-label="close" icon="close" variant="naked" onClick={onClose} />
          </Flex>
        ),
      }}
    >
      <Container justifyContent="center" alignItems="center">
        <Box maxW="container.lg">
          <Routes>
            <Route index element={<Navigate to={SubscriptionTabsEnum.Plans} replace />} />
            <Route
              path={`/${SubscriptionTabsEnum.Plans}/*`}
              element={<SubscriptionPlansActivity returnUrl={returnUrl} />}
            />
            <Route
              path={`/${SubscriptionTabsEnum.Checkout}/*`}
              element={<SubscriptionCheckoutActivity returnUrl={returnUrl} planId={planId} />}
            />
          </Routes>
        </Box>
      </Container>
    </Layout>
  );
};
